import { DataSnapshot, off, onValue, ref, remove } from "firebase/database";
import { Errors, trackError } from "modules/monitoring";
import { asyncResult } from "services/firebaseService/firebase";
import { IUser } from "modules/app/types";
import {
  INVITE_PATH,
  ROOM_PATH,
  EVENT_PATH,
  SPACE_PATH,
  USER_PATH,
} from "services/firebaseService/storagePaths";
import { database } from "services/firebaseService/firebaseConfig";
import { IRoomBase } from "types";

interface InviteListenerArgs {
  fromUser: IUser;
  targetTable: IRoomBase;
  inviteId: string;
  targetFloorId: string;
  notifyDialogType?: string;
}

export const unsubscribeRoomInvite = (
  eventId: string,
  userId: string,
): void => {
  const inviteRef = ref(
    database,
    `${EVENT_PATH}/${eventId}/${INVITE_PATH}/${userId}`,
  );

  off(inviteRef);
};

type InviteListener = (props: InviteListenerArgs) => void;

export const subscribeRoomInvite = (
  eventId: string,
  userId: string,
  onReceiveInvite: InviteListener,
): void => {
  const inviteRef = ref(
    database,
    `${EVENT_PATH}/${eventId}/${INVITE_PATH}/${userId}`,
  );

  off(inviteRef);
  onValue(inviteRef, async (snapshot: DataSnapshot) => {
    const invite = snapshot.val();

    if (!invite) {
      return;
    }

    const userRef = ref(
      database,
      `${EVENT_PATH}/${eventId}/${USER_PATH}/${invite.fromId}`,
    );

    const roomRef = ref(
      database,
      `${SPACE_PATH}/${invite.targetFloorId}/${ROOM_PATH}/${invite.targetTableId}`,
    );

    let fromUser: IUser;
    let targetTable: IRoomBase;

    try {
      fromUser = await asyncResult(userRef);
      targetTable = await asyncResult(roomRef);
      targetTable.id = invite.targetTableId;

      remove(inviteRef);
    } catch (error) {
      trackError(error, {
        label: Errors.FB_HANDLE_INVITED,
        ...invite,
      });
      return;
    }

    onReceiveInvite({
      fromUser,
      targetTable,
      inviteId: invite.inviteId,
      targetFloorId: invite.targetFloorId,
      notifyDialogType: invite.notifyDialogType,
    });
  });
};
